import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("common");

  return (
    <footer className="bg-ax-dark-alt text-white">
      <div className="px-6 md:px-12 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 mb-16">
          <div className="lg:w-1/3">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/1c927f723c274043d230f8a1015ea0aa/a8cf771ba2b07c3ccb8e4bb89c36eb5d.png"
                alt="AX Axis Logo"
                className="h-10 w-auto object-contain"
              />
              <div>
                <p className="font-semibold text-lg">{t("footer.companyName")}</p>
                <p className="text-xs text-ax-silver-dark">
                  {t("footer.companyNameEn")}
                </p>
              </div>
            </div>
            <p className="text-sm text-ax-silver-dark leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="lg:w-2/3 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-medium text-sm mb-4 text-ax-silver">{t("footer.business")}</h4>
              <ul className="space-y-3">
                {[t("footer.business.storageChips"), t("footer.business.terminalDevices"), t("footer.business.privateCloudNAS"), t("footer.business.enterpriseNetwork")].map(
                  (item) => (
                    <li key={item}>
                      <span className="text-sm text-ax-silver-dark hover:text-white transition-colors cursor-pointer">
                        {item}
                      </span>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-sm mb-4 text-ax-silver">{t("footer.aboutUs")}</h4>
              <ul className="space-y-3">
                {[t("footer.aboutUs.brandVision"), t("footer.aboutUs.strategicPositioning"), t("footer.aboutUs.developmentRoadmap"), t("footer.aboutUs.careers")].map(
                  (item) => (
                    <li key={item}>
                      <span className="text-sm text-ax-silver-dark hover:text-white transition-colors cursor-pointer">
                        {item}
                      </span>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-sm mb-4 text-ax-silver">{t("footer.contact")}</h4>
              <ul className="space-y-3">
                <li className="text-sm text-ax-silver-dark">
                  {t("footer.addressLine1")}
                </li>
                <li>
                  <a
                    href="mailto:contact@axaxis.com"
                    className="text-sm text-ax-silver-dark hover:text-white transition-colors"
                  >
                    {t("footer.emailLabel")}contact@axaxis.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-ax-silver-dark">
            {t("footer.copyright").replace("{{year}}", new Date().getFullYear().toString())}
          </p>
        </div>
      </div>
    </footer>
  );
}